import {StyleSheet, TouchableOpacity} from 'react-native';
import {Plus} from 'lucide-react-native';
import {useCurrentTheme} from '@/theming/useCurrentTheme';
import {ThemeType} from '@/theming/baseTheme';
import {createShadows} from '@/theming/shadows';

interface SharedFolderFABProps {
    onPress: () => void;
}

export const SharedFolderFAB = ({onPress}: SharedFolderFABProps) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <TouchableOpacity
            style={styles.fab}
            onPress={onPress}
            activeOpacity={0.8}
        >
            <Plus size={24} color="white" />
        </TouchableOpacity>
    );
};

const createStyles = (theme: ThemeType) => {
    const shadows = createShadows(theme);

    return StyleSheet.create({
        fab: {
            position: 'absolute',
            bottom: 24,
            right: 24,
            width: 56,
            height: 56,
            borderRadius: 28,
            backgroundColor: theme.colors.primary,
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            ...shadows.lg,
        },
    });
};
